export class LazyLoader {
  constructor(scriptUrl, className, ...constructorArgs) {
    this.scriptUrl = scriptUrl;
    this.className = className;
    this.instance = null;
    this.callQueue = [];
    this.isLoading = false;
    this.constructorArgs = constructorArgs;
    this.proxy = new Proxy(this, {
      get: (target, prop) => {
        if (target.instance) {
          this.log(`Proxying call: ${prop}`);
          const value = target.instance[prop];
          if (typeof value === "function") {
            return (...args) => {
              return new Promise((resolve, reject) => {
                try {
                  const result = value.apply(target.instance, args);
                  if (result instanceof Promise) {
                    result.then(resolve).catch(reject);
                  } else {
                    resolve(result);
                  }
                } catch (error) {
                  reject(error);
                }
              });
            };
          } else {
            return value;
          }
        } else {
          return (...args) => {
            this.log(`Caching call: ${prop}(${args.join(", ")})`);
            return new Promise((resolve, reject) => {
              target.callQueue.push({
                method: prop,
                args,
                resolve,
                reject
              });
              if (!target.isLoading) {
                target.loadScript();
              }
            });
          };
        }
      }
    });
  }
  loadScript() {
    const analyticsScript = document.querySelector(`script[src='${this.scriptUrl}']`);
    if (!analyticsScript) {
      this.isLoading = true;
      const script = document.createElement("script");
      script.src = this.scriptUrl;
      this.log(`Loading script: ${this.scriptUrl}`);
      script.onload = () => {
        this.isLoading = false;
        this.log(`Script loaded: ${this.scriptUrl}`);
        this.initializeInstance();
      };
      script.onerror = () => {
        console.error(`Failed to load script: ${this.scriptUrl}`);
      };
      document.head.appendChild(script);
    }
  }
  initializeInstance() {
    const module = window[this.className];
    if (module) {
      const ClassToInstantiate = module.default || module;
      this.instance = new ClassToInstantiate(...this.constructorArgs);
      this.callQueue.forEach(({ method, args, resolve, reject }) => {
        try {
          const result = this.instance[method](...args);
          if (result instanceof Promise) {
            result.then(resolve).catch(reject);
          } else {
            resolve(result);
          }
        } catch (error) {
          reject(error);
        }
      });
      this.callQueue = [];
    } else {
      console.error(`Class ${this.className} is not defined in the script.`);
    }
  }
  log(message) {
    if (window.TINT_LOG) {
      console.log(message);
    }
  }
  getProxy() {
    return this.proxy;
  }
}
